<sura-admin [linkActive] = "linkActive"></sura-admin>
<div class="container  pl-0 pr-0" >
    <div style="padding: 10px 0px"></div>
    <div class="card shadow mb-5 bg-white rounded " style="margin: auto;">
        <div class="card-header">
            Administraci&oacute;n de Asambleas
        </div>

        <form class="card-body" [formGroup]="busquedaForm">

          <div class="form-row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Nro. Asamblea</mat-label>
                <input matInput name="idAsamblea" formControlName="idAsamblea" placeholder="">
                <mat-error *ngIf="hasError('idAsamblea')">Ingrese un n&uacute;mero correcto</mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                  <mat-label>Fondo</mat-label>
                  <mat-select formControlName="idOrganizador" name="idOrganizador" placeholder="Seleccione" >
                      <mat-option value="" >Todos</mat-option>
                      <mat-option *ngFor="let element of listaOrganizadores" [value]="element.idOrganizador">
                              {{element.organizador}}
                      </mat-option>
                  </mat-select>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Fecha</mat-label>
                <input matInput formControlName="fechaRegistro" name="fechaRegistro" [min]="minDate" [max]="maxDate" [matDatepicker]="picker" placeholder="dd/mm/yyyy" >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker disabled="false"></mat-datepicker>
                <mat-error *ngIf="hasError('fechaRegistro')">Ingrese una fecha correcta</mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="estado" name="estado" placeholder="Seleccione" >
                  <mat-option value="" >Todos</mat-option>
                  <mat-option *ngFor="let estado of listaEstados" [value]="estado.codigo" >
                    {{estado.descripcion}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col">
              <button mat-mini-fab color="primary" matTooltip="Buscar" [disabled]="!busquedaForm.valid" (click)="buscarAsambleas()" >
                  <mat-icon>search</mat-icon>
              </button>
              <button mat-mini-fab color="primary" matTooltip="Limpiar" (click)="busquedaForm.reset()" >
                  <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>

        </form>

        <mat-divider></mat-divider>

        <div class="d-flex justify-content-end mt-2 pr-2 padding-bottom-10">
          <button mat-raised-button color="primary" routerLink="/asamblea/registrar"><mat-icon>post_add</mat-icon> &nbsp;&nbsp;Registrar Asamblea</button>
        </div>

        <div class="mat-elevation-z4">
            <div class="example-container ">
                <table mat-table [dataSource]="dataSource" aria-describedby="tabla bandeja de asamblea">

                    <!-- --ASAMBLEA  -->
                    <ng-container matColumnDef="ASAMBLEA" >
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> ASAMBLEA   </th>
                        <td mat-cell *matCellDef="let element" class="text-center txt-sura-centred">{{element.idAsamblea}}</td>
                    </ng-container>

                    <!-- --TITULAR  -->
                    <ng-container matColumnDef="FONDO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> FONDO    </th>
                        <td mat-cell *matCellDef="let element" class="text-left txt-sura-centred">{{element.managerAsamblea}}</td>
                    </ng-container>

                    <!-- --FECHA   -->
                    <ng-container matColumnDef="FECHA">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> FECHA  </th>
                        <td mat-cell *matCellDef="let element" class="text-left txt-sura-centred"> {{ element.fechaInicio | date : "dd/MM/yyyy" }} </td>
                    </ng-container>

                    <!-- --ESTADO   -->
                    <ng-container matColumnDef="ESTADO">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header scope="col"> ESTADO  </th>
                        <td mat-cell *matCellDef="let element" class="text-left txt-sura-centred"> {{ obtenerEstado(element.estado) }} </td>
                    </ng-container>

                    <!-- --OPCIONES   -->
                    <ng-container matColumnDef="OPCIONES">
                        <th mat-header-cell *matHeaderCellDef scope="col">OPCIONES</th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            <button  matTooltip="Editar asamblea" mat-icon-button color="primary" type="button" [routerLink]="'/asamblea/' + element.idAsamblea"  [disabled]="deshabilitarBtn('Editar', element.estado)" >
                                <mat-icon aria-label="icon-button with a heart icon">edit</mat-icon>
                            </button>
                            <button  matTooltip="Cambiar estado" mat-icon-button color="primary" type="button" (click)="openDialogEstado(element.idAsamblea, element.estado)" [disabled]="deshabilitarBtn('Cambiar', element.estado)">
                                <mat-icon aria-label="icon-button with a heart icon">swap_horizontal_circle</mat-icon>
                            </button>
                            <button  matTooltip="Eliminar asamblea" mat-icon-button color="primary" type="button" (click)="editarEstado(element.idAsamblea, 'E')" [disabled]="deshabilitarBtn('Eliminar', element.estado)">
                                <mat-icon aria-label="icon-button with a heart icon">delete</mat-icon>
                            </button>
                            <button *ngIf="element.bloquearVoto =='S'" matTooltip="Bloquear votación" mat-icon-button color="primary" type="button" (click)="editarBloqueo(element.idAsamblea, 'N')">
                              <mat-icon aria-label="icon-button with a heart icon">lock</mat-icon>
                            </button>
                            <button *ngIf="element.bloquearVoto == 'N'" matTooltip="Desbloquear votación" mat-icon-button color="primary" type="button" (click)="editarBloqueo(element.idAsamblea, 'S')">
                              <mat-icon aria-label="icon-button with a heart icon">lock_open</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                </table>
            </div>
            <div *ngIf="dataSource.data.length === 0" class="text-center text-secondary p-3">
                <span>No se encontraron resultados</span>
            </div>
            <mat-divider></mat-divider>
            <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
    </div>
</div>
